import { IChatMessageReminder } from './chat/models/chat-message-reminder.interface';
import { ILeadListFiltersOutput } from './leads/leads-list/lead-list-filters/lead-list-filters.component';
import { Notes } from './models/notes';

export interface StatusGroup {
    name: string;
    id?: number;
    samplesOnly?: number;
}

export interface CallAiTranscriptLine {
    speaker?: 'customer' | 'agent' | 'system';
    text: string;
    partial?: boolean;
    createdAt?: string;
}

export interface CallAiPriceMatch {
    title: string;
    price?: number;
    unit?: string;
    availability?: string;
    confidence?: number;
}

export interface CallAiActionCandidate {
    type: string;
    label: string;
    reason?: string;
}

export interface CallAiAssistState {
    status: 'idle' | 'matching' | 'listening' | 'ready' | 'unavailable';
    intent: string;
    confidence: number | null;
    suggestedReply: string;
    transcript: Array<CallAiTranscriptLine>;
    priceMatches: Array<CallAiPriceMatch>;
    actionCandidates: Array<CallAiActionCandidate>;
    updatedAt: string | null;
}

export interface CallDataToggleType {
    showOrderDetails: boolean;
    showAvailableAgents: boolean;
    showNewCallNote: boolean;
    showCallNotes: boolean;
}

export interface CallDataType extends CallDataToggleType {
    contact: any;
    orders: any;
    notes: Array<Notes>;
    aiAssist: CallAiAssistState;
}

enum ValidDomains {
    UP = 'up',
    YS = 'ys',
}

export interface Domain {
    id: ValidDomains;
    name: string;
}

export const defaultCallAiAssistState: CallAiAssistState = {
    status: 'idle',
    intent: '',
    confidence: null,
    suggestedReply: '',
    transcript: [],
    priceMatches: [],
    actionCandidates: [],
    updatedAt: null,
};

export const defaultCallDataToggle: CallDataToggleType = {
    showOrderDetails: false,
    showAvailableAgents: false,
    showNewCallNote: false,
    showCallNotes: false,
};

export const defaultCallData = {
    contact: null,
    orders: null,
    notes: [],
    aiAssist: { ...defaultCallAiAssistState },
    ...defaultCallDataToggle,
} as CallDataType;

export interface State {
    productSearchShowJoblots: boolean;
    jobLotParams: any;
    modules: any;
    onlineUsers: any[];
    allUsers: any[];
    typingUsers: any;
    domains: Domain[];
    domain: string;
    statusGroups: StatusGroup[];
    hideMenu: boolean;
    isSideBarOpen: boolean;
    device: any;
    alerts: any;
    user: any;
    chatStore: any;
    faq: any;
    confirmationData: any;
    blogCategories: any;
    companyRequests: any[];
    notifications: any;
    orderCreateSteps: any;
    asideOpen: boolean;
    growler: any;
    returnRoute: string;
    menuItems: any[];
    activeMenuItem: any;
    overlays: any;
    overlayData: any;
    menuOpen: boolean;
    baskets: any;
    headerContent: any;
    ttl: number;
    token: string;
    loggedIn: boolean;
    basketId: string;
    basket: any;
    ordersDashboard: any[];
    samplesDashboard: any[];
    orderDetailBoard: any;
    orders: any[];
    samples: any[];
    changeTrigger: any;
    updatedOrderLine: any;
    updatedOrderBoard: any;
    settings: any;
    errors: any[];
    call: CallDataType;

    cahtReminders: IChatMessageReminder[];
    openedChatSK: any;
    confirmationEmail: string;
    supplier: any;
    accountType: string;
    bespokePricingLog: [];
    basketPrevious: any;
    activeNotification: any;
    cropImage: any;
    lastBasketItemAdded: any;

    leadsFilters: { showFilters: boolean; filters: ILeadListFiltersOutput };
}
